import { XlsxManager } from "./xlsxManager";
import { DateHelpers } from "./dateHelpers";
import { CodeGenerator } from "./codeGenerator";
import { eventEmitter } from "./eventEmitter";
import { NetHelpers } from "./NetHelpers";
import { AttendanceHelper } from "./attendance";

export const Helpers = {
	XlsxManager,
	DateHelpers,
	CodeGenerator,
	eventEmitter,
	NetHelpers,
	AttendanceHelper
};